module.exports = __webpack_public_path__ + "static/media/document.7ecf0528.svg";